import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

var basicAction = function basicAction(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? null : _ref$color;
  var cssModifier = [];

  if (color && color[0]) {
    if (color[1] !== null) cssModifier.push("color-".concat(color[0], "-").concat(color[1]));else cssModifier.push("color-".concat(color[0]));
  }

  return cssModifier;
};

var instance = [basicAction];

var pipe = function pipe() {
  return {
    getInstance: function getInstance() {
      return instance;
    },
    add: function add(customModifier) {
      instance.push(customModifier);
    },
    execute: function execute(props) {
      return instance.reduce(function (temp, action) {
        return [].concat(_toConsumableArray(temp), _toConsumableArray(action(props)));
      }, []);
    }
  };
};

export default pipe;
//# sourceMappingURL=convertPropsToColorModifiers.js.map
